import { LineItem } from 'types';

export const normalizeLineItemPrice = (lineItem: LineItem): LineItem => {
  if (
    lineItem.price === null ||
    lineItem.price === undefined ||
    Number.isNaN(lineItem.price) ||
    lineItem.price === ''
  ) {
    return {
      ...lineItem,
      price: 0,
    };
  }
  return lineItem;
};
